import React from "react";
import AppContainer from "../../../components/AppContainer";
import ExportButton from "../../../components/ExportButton";
import CustomRangePicker from "../../../components/DateRangePicker";
import { MenuItem, Stack } from "@mui/material";
import CustomSelect from "../../../components/customSelect";
import { allIcons } from "../../../assets";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/education/EducationClasses.json";

const allClasses = ["Class 1", "Class 2", "Class 3", "Class 4"];
const status = ["Paid", "Remain", "Not Paid"];

const headerData = [
  "ID",
  "Created At",
  "Class Detail",
  "Class Fee Structure",
  "Student Limit",
  "Action",
];

const displayRows = [
  "_id",
  "date_time",
  "ed_class_detail",
  "ed_class_fee_structure",
  "ed_class_limits",
  "actions",
];

const AllClasses = () => {
  // Render top right part on template
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <ExportButton handleClick={() => console.log("helllo")} />
        <CustomRangePicker
          stackProps={{
            borderRadius: "6px",
            border: "1px solid #dddddd",
          }}
        />
      </Stack>
    );
  };

  const renderSearchers = () => {
    return (
      <Stack flex={1} direction={"row"} alignItems={"center"} gap={1}>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.classBlackIcon} width={16} />}
          placeholder={"By Class"}
        >
          {allClasses.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.timerBlackIcon} width={16} />}
          placeholder={"Status"}
        >
          {status.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.cashBundleBlackIcon} width={16} />}
          placeholder={"Fee Structure"}
        >
          <MenuItem value={"Pay All"}>Pay All</MenuItem>
          <MenuItem value={"Installments"}>Installments</MenuItem>
        </CustomSelect>
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"All Classes"}
      secondaryHeading={"View, add, edit and delete classes"}
      headProps={renderRightPart()}
      showSerach={true}
      searchMenuProps={renderSearchers()}
    >
      <DynamicTable
        tableHeader={headerData}
        displayRows={displayRows}
        tableData={TableData}
        showActions={true}
        showEdit={true}
        showDelete={true}
        showView={true}
      />
    </AppContainer>
  );
};

export default AllClasses;
